"use strict";

require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var Languages_1 = require("Core/Languages");
var CommonFunctions_1 = require("Components/CommonFunctions");
exports.AddCartModal = function () {
  var Selector = {
    MODAL: '#cart-modal',
    SLIDER_CONTAINER: '#cart-modal .js_common_products_carousel',
    ADD_TO_CART_SHOW_SUGGEST: '.show-suggests',
    ADD_TO_CART_BTN: '.js_product_page_add_to_cart.show-suggests',
    ADD_TO_CART_CATEGORY_BTN: '.js_category_page_add_to_cart.show-suggests'
  };
  $(Selector.ADD_TO_CART_SHOW_SUGGEST).on('AddedToBasket', getSuggestProducts);
  function getSuggestProducts() {
    var urlLang = Languages_1.getCurrentLanguageUrl;
    var id = $(this).data('product-id');
    $(Selector.MODAL).html('');
    $.ajax({
      url: urlLang + "/product-card/get-suggestions/" + id,
      type: 'GET',
      dataType: 'html',
      success: function success($content) {
        if ($content != undefined && $content != '') {
          $(Selector.MODAL).html($content);
          initProductsCarousel();
          CommonFunctions_1.openModal($(Selector.MODAL));
        }
      },
      error: function error() {}
    });
  }
  function initProductsCarousel() {
    if ($(Selector.SLIDER_CONTAINER).length) {
      $(Selector.SLIDER_CONTAINER).slick({
        dotsClass: 'slick-dots-button',
        infinite: false,
        arrows: true,
        dots: false,
        fade: false,
        autoplay: false,
        autoplaySpeed: 4000,
        adaptiveHeight: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipe: false,
        rows: 0,
        prevArrow: '<button type="button" class="arrow arrow-prev h-100"><i class="fas fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="arrow arrow-next h-100"><i class="fas fa-chevron-right"></i></button>',
        responsive: [{
          breakpoint: 1499,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 991,
          settings: {
            slidesToShow: 1
          }
        }, {
          breakpoint: 479,
          settings: {
            slidesToShow: 1
          }
        }]
      });
    }
  }
}();